module.exports = function(h, row) {
    if (row.default) {
        return <i>N/A</i>;
    }

    if (!row.outlets.length) {
        return <i>No outlet Assigned</i>;
    }

    if (row.outlets.length === 1) {
        return row.outlets[0].name;
    }

    return <i>Assigned to {row.outlets.length} outlets</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/central-settings/outlet-column.jsx